<quill-editor khA11yField [khA11yLabel]="'INPUT_TEXT_EDITOR.EDITOR' | translate" [modules]="modules" trackChanges="user" [format]="editorFormat" [ngModel]="text" (ngModelChange)="changeValue($event)" class="tinymce-editor GsEditField QuestionText d-block" [ngClass]="getEditorClass()" (onEditorCreated)="editorCreated($event)" (onSelectionChanged)="selectionChanged($event)" [placeholder]="'INPUT_TEXT_EDITOR.INSERT_TEXT_HERE' | translate ">
  <div quill-editor-toolbar khA11yGroup [khA11yLabel]="'INPUT_TEXT_EDITOR.TOOLBAR' | translate">
    <span class="ql-formats" [class.untouchable]="isCodeMode()">
      <select class="ql-size" khA11yField [khA11yLabel]="'INPUT_TEXT_EDITOR.FONT_SIZE' | translate">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
    </span>
    <span class="ql-formats" [class.untouchable]="isCodeMode()">
      <button class="ql-bold" [khA11yLabel]="'INPUT_TEXT_EDITOR.BOLD' | translate"></button>
      <button class="ql-italic" [khA11yLabel]="'INPUT_TEXT_EDITOR.ITALIC' | translate"></button>
    </span>
    <span class="ql-formats" [class.untouchable]="isCodeMode()">
      <select class="ql-color" khA11yField [khA11yLabel]="'INPUT_TEXT_EDITOR.TEXT_COLOR' | translate"></select>
      <select class="ql-background" khA11yField [khA11yLabel]="'INPUT_TEXT_EDITOR.BACKGROUND_COLOR' | translate"></select>
    </span>
    <span class="ql-formats" [class.untouchable]="isCodeMode()">
      <button class="ql-list" value="ordered" [khA11yLabel]="'INPUT_TEXT_EDITOR.ORDERED_LIST' | translate"></button>
      <button class="ql-list" value="bullet" [khA11yLabel]="'INPUT_TEXT_EDITOR.BULLET_LIST' | translate"></button>
      <select class="ql-align" khA11yField [khA11yLabel]="'INPUT_TEXT_EDITOR.TEXT_ALIGNMENT' | translate">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
    <span class="ql-formats" [class.untouchable]="isCodeMode()">
      <button class="ql-link" [khA11yLabel]="'INPUT_TEXT_EDITOR.LINK' | translate"></button>
      <button class="ql-upload-file" [class.ql-active]="isImageSelected" (click)="uploadClicked($event)" [khA11yLabel]="'INPUT_TEXT_EDITOR.UPLOAD_FILE' | translate">
        <fa-icon khA11yHidden [icon]="['fas', 'photo-video']"></fa-icon>
      </button>
      <button class="ql-format" [class.ql-active]="isCodeMode()" (click)="changeEditorFormat()" [khA11yPressed]="isCodeMode()" [khA11yLabel]="(isCodeMode() ? 'INPUT_TEXT_EDITOR.RICH_TEXT_MODE' : 'INPUT_TEXT_EDITOR.CODE_MODE') | translate">
        <fa-icon khA11yHidden [icon]="['fas', 'code']"></fa-icon>
      </button>
    </span>
  </div>
</quill-editor>
<kh-upload-file-modals-holder *ngIf="showUpload" [sourceImage]="sourceImage" [imagePath]="imagePath" (hideModals)="hideModals($event)"></kh-upload-file-modals-holder>